export default "__VITE_ASSET__DX9L$3Ql__"